import { render, staticRenderFns } from "./ActionAttachments.vue?vue&type=template&id=214989d6"
import script from "./ActionAttachments.vue?vue&type=script&lang=js"
export * from "./ActionAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports